import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Wordmark from "./Wordmark";
import { ENABLE_PERSISTENT_FILES } from "@/config/features";

const NAV = [
  { label: "Abonelik İptali", to: "/abonelik-iptali" },
  { label: "İade & İtiraz", to: "/iade-itiraz" },
  { label: "Hakem Heyeti", to: "/tuketici-hakem-heyeti" },
  { label: "Haklarınızı Öğrenin", to: "/haklarinizi-ogrenin" },
  { label: "Nasıl Çalışır?", to: "/nasil-calisir" },
  ...(ENABLE_PERSISTENT_FILES ? [{ label: "Dosyalarım", to: "/dosyalarim" }] : []),
];

export default function Header({ onStart }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const startFile = () => {
    if (onStart) onStart();
    else navigate("/dosya-baslat");
  };
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200"
    >
      <div className="fs-wide-container h-16 md:h-[72px] flex items-center justify-between gap-2 sm:gap-4">
        <Link to="/" data-testid="header-logo-link" aria-label="Abonelik İptal ana sayfa" className="flex min-w-0 items-center">
          <Wordmark size="md" />
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace("/", "")}`}
              className="px-4 py-2 rounded-full text-sm font-semibold text-slate-600 hover:text-[#0F3D4A] hover:bg-slate-100 transition-colors"
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <button
            data-testid="header-start-btn"
            className="fs-btn-primary text-sm"
            onClick={startFile}
          >
            Başvuru Hazırla
          </button>
        </div>
        <button
          className="lg:hidden shrink-0 p-2 rounded-full hover:bg-slate-100 transition-colors"
          onClick={() => setOpen((v) => !v)}
          data-testid="header-mobile-toggle"
          aria-label="Menüyü aç"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-md">
          <div className="fs-wide-container py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mnav-${n.to.replace("/", "")}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-xl text-[#0F172A] hover:bg-slate-100"
              >
                {n.label}
              </Link>
            ))}
            <button
              data-testid="mnav-start-btn"
              onClick={() => {
                setOpen(false);
                startFile();
              }}
              className="fs-btn-primary mt-2 self-start"
            >
              Başvuru Hazırla
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
